// Aleluya custom — logo animado: "aleluya" + triángulo fijo con glitch
// La animacion es 100% CSS; este script solo congela el triangulo en su
// estado claro si el usuario prefiere movimiento reducido.
(function () {
  function initLogo() {
    var els = document.querySelectorAll('[data-aleluya-logo-a]');
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var tri = el.querySelector('.aleluya-glyph__tri');
        var ghosts = el.querySelectorAll('.aleluya-glyph__ghost');
        if (tri) { tri.style.animation = 'none'; tri.style.transform = 'translate(0,0) rotate(0deg)'; tri.style.opacity = '1'; }
        for (var j = 0; j < ghosts.length; j++) { ghosts[j].style.animation = 'none'; ghosts[j].style.opacity = '0'; }
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogo);
  } else {
    initLogo();
  }
})();
// Aleluya custom — menú móvil: al tocar un elemento de PRIMER nivel
// (Men, Women, Accessories, Sale...) se despliega o recoge su submenú,
// sin necesidad de tocar la flechita. Las subcategorías de todos los
// niveles aparecen ya abiertas (se controla por CSS).
(function () {
  function onDocumentClick(e) {
    var link = e.target && e.target.closest ? e.target.closest('.mobile-menu-link') : null;
    if (!link) return;
    var label = link.closest('.submenu__label');
    if (!label) return;
    var holder = label.parentElement;
    if (!holder || !holder.classList || !holder.classList.contains('mobile-menu__first-level')) return;
    var forId = label.getAttribute('for');
    if (!forId) return;
    var input = document.getElementById(forId);
    if (!input) return;
    e.preventDefault();
    input.checked = !input.checked;
  }
  function init() {
    document.addEventListener('click', onDocumentClick);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Aleluya custom — newsletter -> Mailchimp
// Envia el email a Mailchimp (audiencia principal) sin bloquear el envio
// nativo de Shopify, que sigue registrando al cliente como antes.
(function () {
  var ENDPOINT = 'https://aleluya-newsletter-s-vqskyf.abacusai.app/api/newsletter';
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (!tags || tags.value.indexOf('newsletter') === -1) return;
    var input = form.querySelector('input[type="email"]');
    var email = input && input.value ? input.value.trim() : '';
    if (!email) return;
    try {
      fetch(ENDPOINT, {
        method: 'POST', keepalive: true, mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email })
      }).catch(function () {});
    } catch (err) {}
  }, true);
})();
